var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEncrypted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.45 30h5.1l-1.25-7.25c.667-.3 1.2-.742 1.6-1.325.4-.583.6-1.225.6-1.925 0-.967-.342-1.792-1.025-2.475C25.792 16.342 24.967 16 24 16c-.967 0-1.792.342-2.475 1.025-.683.683-1.025 1.508-1.025 2.475 0 .7.2 1.342.6 1.925.4.583.933 1.025 1.6 1.325L21.45 30ZM24 43.95c-4.667-1.167-8.5-3.875-11.5-8.125S8 26.917 8 21.85V9.95l16-6 16 6v11.9c0 5.067-1.5 9.725-4.5 13.975S28.667 42.783 24 43.95Zm0-3.1c3.833-1.267 6.958-3.658 9.375-7.175S37 26.217 37 21.85v-9.8l-13-4.9-13 4.9v9.8c0 4.367 1.208 8.308 3.625 11.825 2.417 3.517 5.542 5.908 9.375 7.175Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEncrypted);
export default __webpack_public_path__ + "static/media/icon_encrypted.e528eddbb42b5cd9aef0c21e436443ca.svg";
export { ForwardRef as ReactComponent };